import React, { memo, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { getVisitTasksActions } from '../../../redux/actions/visitTasksActions';
import Button from '../../shared/buttons/Button';
import ContainerHeader from '../../shared/container/ContainerHeader';
import ContainerTitle from '../../shared/container/ContainerTitle';
import CreateVisitTaskModal from './modals/CreateVisitTaskModal';

const VisitTasksHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit?.visit);
  const [showCreateVisitTaskModal, setShowCreateVisitTaskModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleVisitTaskModalSubmit = async () => {
    setShowCreateVisitTaskModal(false);
    setLoading(true);
    await dispatch(getVisitTasksActions(vin, id));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateVisitTaskModal && (
        <CreateVisitTaskModal
          onModalSubmit={() => handleVisitTaskModalSubmit()}
          onModalClose={() => setShowCreateVisitTaskModal(false)}
        />
      )}
      <ContainerTitle title={'Послуги візиту'} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateVisitTaskModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default memo(VisitTasksHeader);
